import i18n from '../../../i18n';
import { arraySortAscendingFunction, reverseDate } from '../../utilities';

export const getWozObjectData = (wozJson) => {
    let items = [];
    let fields = [];

    if (!wozJson) {
        return {
            items,
            fields
        };
    }

    for (let i = 0, l = wozJson.length; i < l; i++) {
        const hasWaardenValues = wozJson[i].waarden && wozJson[i].waarden.length > 0;

        items.push({
            // provide a unique ID column to avoid conflicts with the ID column in the data
            nedGlobeRowId: i,
            adres: formatAddress(wozJson[i].aanduiding),
            identificatie: wozJson[i].identificatie,
            nummeraanduidingIdentificatie: wozJson[i].aanduiding?.nummeraanduidingIdentificatie,
            grondoppervlakte: `${wozJson[i].grondoppervlakte}m\xB2`,

            // show only the most recent one
            vastgesteldeWaarde: hasWaardenValues ? `${wozJson[i].waarden[0]?.vastgesteldeWaarde.toLocaleString()} euro` : '',
            ingangsdatum: hasWaardenValues ? reverseDate(wozJson[i].waarden[0]?.ingangsdatum) : '',
            waardepeildatum: hasWaardenValues ? reverseDate(wozJson[i].waarden[0]?.waardepeildatum) : '',
            beschikkingsStatussen: hasWaardenValues ? wozJson[i].waarden[0]?.beschikkingsStatussen.join(', ') : '',

            // show only the most recent one
            adresseerbaarObjectIdentificatie: wozJson[i].adresseerbaarObjectIdentificaties[0],
        });
    }

    if (items.length > 0) {
        fields.push(
            {
                key: 'adres',
                label: i18n.t('woz.address'),
                sortable: true,
                showField: true
            },
            {
                key: 'identificatie',
                label: i18n.t('woz.identification'),
                sortable: true,
                showField: true
            },
            {
                key: 'grondoppervlakte',
                label: i18n.t('woz.grondoppervlakte'),
                sortable: true,
                showField: true
            },
            {
                key: 'waardepeildatum',
                label: i18n.t('woz.waardepeildatum'),
                sortable: true,
                showField: true
            },
            {
                key: 'vastgesteldeWaarde',
                label: i18n.t('woz.vastgesteldeWaarde'),
                sortable: true,
                showField: true
            },
            {
                key: 'ingangsdatum',
                label: i18n.t('woz.ingangsdatum'),
                sortable: true,
                showField: true
            },
            {
                key: 'beschikkingsStatussen',
                label: i18n.t('woz.beschikkingsStatussen'),
                sortable: true,
                showField: true
            },
            {
                key: 'adresseerbaarObjectIdentificatie',
                label: i18n.t('woz.addressableObjectId'),
                sortable: true,
                showField: true
            },
            {
                key: 'nummeraanduidingIdentificatie',
                label: i18n.t('woz.numberDesignation'),
                sortable: true,
                showField: true
            }
        );
    }

    // sort items
    items.sort(arraySortAscendingFunction('identificatie'));

    return {
        items,
        fields: fields.filter(({ showField }) => showField),
        sortBy: 'identificatie',
        selectable: true
    };
};

const formatAddress = (data) => {
    if (data) {
        // join strings with a space, only if strings are not null or empty
        return [
            data.straat,
            data.huisnummer,
            data.huisletter,
            data.huisnummertoevoeging,
            data.postcode,
            data.woonplaats
        ]
            .filter((val) => val)
            .join(' ');
    }
    return '';
};
